/**
 * Les outils qu'un article peut porter en entier, à la place d'une capture.
 *
 * Le contenu stocké en base pose un marqueur :
 *   <div data-article-tool="combien-facturer"><p><a href="…">…</a></p></div>
 * et helpers/transformHtml.js le remplace par le vrai simulateur, que seule la
 * page d'un article sait rendre (components/content/ArticleTool/
 * renderArticleTools.jsx, puis ArticleTool.jsx). Le paragraphe intérieur
 * est le repli : un lien vers l'outil, que l'éditeur affiche et qu'un rendu
 * sans le marqueur laisse lisible.
 *
 * POURQUOI UNE LISTE À PART ET PAS LE REGISTRE : transformHtml tourne aussi
 * dans le navigateur (messages, aperçus d'admin). lib/tools/registry.js y
 * enverrait ses neuf mille lignes. Ici, seuls les slugs et les noms ;
 * scripts/check-article-content.mjs vérifie que chaque clé existe dans le
 * registre et y est intégrable (simulateur ou diagnostic).
 *
 * La clé est celle de l'outil dans le registre (`cle`).
 */
export const ARTICLE_TOOLS = {
    "combien-facturer": {
        fr: { slug: "combien-facturer", nom: "Combien facturer" },
        en: { slug: "how-much-to-charge", nom: "How much to charge" },
    },
};

/** L'adresse de la page complète de l'outil, dans la langue de l'article. */
export function articleToolPath(cle, locale = "fr") {
    const outil = ARTICLE_TOOLS[cle];
    if (!outil) return null;
    const langue = locale === "en" ? "en" : "fr";
    return langue === "en" ? `/en/tools/${outil.en.slug}` : `/fr/outils/${outil.fr.slug}`;
}
